import Grid from '@mui/material/Grid';

export const EmptyBlock = () => (
    <Grid item xs={0} md={6} sx={{ display: { xs: 'none', md: 'block' } }} />
);
